import React from 'react';

const RenderOnlyActiveTab = ({ tabKey, tabsActiveKey, children }) => {
	return tabKey === tabsActiveKey
		? children
		: null;
};

export default RenderOnlyActiveTab;
